import '../sass/index.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import FoldContent from './classes/FoldContent';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', (event) => {
  new FoldContent();

  //set clipy defaults
  //close all items
  gsap.to('.clippy-popup__link', {
    y: 240,
    duration: 0,
  });
  gsap.to('.clippy-popup__bg', {
    rotation: 35,
    scaleX: 0,
    duration: 0,
  });
  gsap.to('.clippy-popup__close', {
    y: 240,
    duration: 0,
  });

  const totalDuration = 0.8;

  //animations for clippy popup

  gsap.to('.clippy-popup__link', {
    scrollTrigger: {
      trigger: '.clippy-popup__target',
      toggleActions: 'restart reverse restart reverse',
    },
    y: 0,
    duration: totalDuration,
    ease: 'expo.out',
  });

  gsap.to('.clippy-popup__bg', {
    scrollTrigger: {
      trigger: '.clippy-popup__target',
      toggleActions: 'restart reverse restart reverse',
    },
    scaleX: 1,
    transformOrigin: 'top left',
    rotation: 35,
    duration: totalDuration,
    ease: 'expo.out',
  });

  gsap.to('.clippy-popup__close', {
    scrollTrigger: {
      trigger: '.clippy-popup__target',
      toggleActions: 'restart reverse restart reverse',
    },
    opacity: 1,
    y: 0,
    duration: totalDuration,
    ease: 'expo.out',
  });

  //close clippy popup
  const clippyPopupClose = document.querySelector('.clippy-popup__close');
  if (clippyPopupClose) {
    clippyPopupClose.addEventListener('click', (e) => {
      e.preventDefault();

      //close all items
      gsap.to('.clippy-popup__link', {
        y: 240,
        ease: 'expo.in',
        duration: totalDuration - 0.3,
      });
      gsap.to('.clippy-popup__bg', {
        rotation: 35,
        scaleX: 0,
        ease: 'expo.in',
        duration: totalDuration,
      });
      gsap.to('.clippy-popup__close', {
        y: 240,
        ease: 'expo.in',
        duration: totalDuration - 0.3,
      });

      //disable triggers
      let allTriggers = ScrollTrigger.getAll();
      allTriggers.forEach((anim) => {
        anim.disable();
      });
    });
  }
  //menu logic
  const hamBtn = document.querySelector(
    '.beter-opleiden-nav-header__hamburger'
  );
  const menu = document.querySelector('.beter-opleiden-nav');
  if (hamBtn && menu) {
    hamBtn.addEventListener('click', (e) => {
      e.preventDefault();

      toggleMenu();
    });

    const toggleMenu = () => {
      menu.classList.toggle('open');
      hamBtn.classList.toggle('open');
    };
  }

  //scroll progress

  const progressbar = document.querySelector('.proress-bar-part.active');
  const proressbarName = document.querySelector('.proress-bar-name');

  const positionName = (nameElem, barPos = 0, progressWidth = 0) => {
    let pos = barPos + progressWidth - nameElem.offsetWidth / 2;

    if (pos < 0) {
      pos = 0;
    }

    if (pos > window.innerWidth - nameElem.offsetWidth - 16) {
      pos = window.innerWidth - nameElem.offsetWidth - 16;
    }

    nameElem.style.left = `${pos}px`;
  };

  if (progressbar && proressbarName) {
    //set init bar position
    const barStartPos = progressbar.getBoundingClientRect().left;

    positionName(proressbarName, barStartPos);

    const setProgress = (e) => {
      //calc progress
      const progress =
        (e.currentTarget.scrollY /
          (document.body.scrollHeight - window.innerHeight)) *
        100;

      //set progress
      const barElem = progressbar.querySelector('.proress-bar-part__progress');

      if (barElem) {
        barElem.style.width = `${progress}%`;
      }

      //set content position
      positionName(proressbarName, barStartPos, barElem.offsetWidth);
    };

    //exists
    window.addEventListener('scroll', (e) => setProgress(e));
    window.addEventListener('resize', (e) => setProgress(e));
  }

  //remove unwanted elements in french
  const removeMe = document.querySelectorAll('.removeMeFr');
  if (removeMe && window.location.href.includes('/fr/')) {
    removeMe.forEach((item) => {
      item.outerHTML = '';
    });
  }
});
